import {Obligor, ReportState} from "../model/pro-report/HeaderDetails";
import {ObligorStateShort} from "../model/state/obligor-state-short";
import {Injectable} from "@angular/core";
import {TransitionTypesEnum} from "../model/enum/transition-types-enum";
import {SearchModel} from "../model/search-model";
import {RecentSearch} from "../model/RecentSearch";
import {Router} from "@angular/router";
import {ActionType} from "../model/enum/action-type";
import {TrackService} from "../service/track.service";

@Injectable({
  providedIn: 'root'
})
export class ObligorSearchTable {

  public savedObligors: ObligorStateShort[] = [];

  constructor(private router: Router, private trackService: TrackService) {

  }

  public openProReport(obligor: Obligor, transition: TransitionTypesEnum, recentSearch: RecentSearch): void {
    this.trackService.track(obligor.id, ActionType.SELECT_PRO_REPORT, recentSearch).subscribe();
    // Set default value in case of transition is null
    if (!transition) transition = TransitionTypesEnum.FORWARD_CALENDAR;
    let generateReport = false;
    if (this.isProReportCompleted(obligor.id)) generateReport = true;
    this.navigateProReport(obligor, transition, generateReport, recentSearch);
  }

  navigateProReport(obligor: Obligor, transitionType: TransitionTypesEnum, generateReport: boolean, recentSearch: RecentSearch) {
    let url = 'pro-report';
    if (generateReport) {
      url += '/generatedReport';
    } else {
      url += '/professional';
    }
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([url], {
        state: {
          obligor: obligor,
          recentSearch: recentSearch,
          transitionType: transitionType
        }
      });
    });
  }

  mapFromModelToRecentSearch(searchModel: SearchModel): RecentSearch {
    if (searchModel) {
      return new RecentSearch(searchModel.obligorName, searchModel.stateId, searchModel.cusip);
    }
    return null;
  }

  clear() {
    this.savedObligors = [];
  }

  public isProReportCompleted(obligorId: number): boolean {
    return this.savedObligors.findIndex(s => s.id === obligorId && s.proState === ReportState.COMPLETED) !== -1;
  }


}
